import EventManager from "../store/sqftEventManager";
import store from "../../../../../store";
import PointV2, {CORE_POINT_LAYOUTS} from "../core/shapes/pointV2";
import workspace from "../core/workspace";
import sqftConfig from "../store/sqftConfig";
import {getLockPointPos} from "./freeDrawHelper";
import {getMousePositionOnField} from "../../../helpers/sqftHelper";
import workspaceControllers from "../store/workspaceControllers";

/**
 * @param pos {{x: int, y: int}}
 * @return {PointV2}
 */
export const getWallPoint = (pos) => {
  let pointState = {
    priority: EventManager.priorities.BOX_POINT,
    movable: true,
    isCentered: true,
    isResizedByPoint: false,
    isScaledByPoint: false,
    isVisibleOnHover: true,
    moveCallback: (mousePos, movablePoint, xDiff, yDiff) => {
      void yDiff;
      const reduxState = store.getState();
      const isWallsUpMode = reduxState.sqftMenuState.isWallsUpMode;
      if (!isWallsUpMode) {
        movablePoint.movePosition(mousePos);
      }
    },
    mouseUpCallback: (mousePos, movablePoint) => {
      void mousePos;
      void movablePoint;
      //console.log('mousePos', mousePos);
      //console.log('movablePoint', movablePoint);
    },
    mouseDownCallback: (mousePos, movablePoint) => {
      //console.log('mouseDownCallback mousePos', mousePos);
      //console.log('mouseDownCallback movablePoint', movablePoint);
      void mousePos; void movablePoint;
      const reduxState = store.getState();
      const isWallsUpMode = reduxState.sqftMenuState.isWallsUpMode;
      if (isWallsUpMode) {
        const wall = workspaceControllers.walls.getWallByPoint(movablePoint.parent);
        wall.editWall(movablePoint.parent);
        return true
      }
    }
  };
  let pointDesign = {
    radius: 10,
    lineWidth: 1,
    layout: CORE_POINT_LAYOUTS.black
  };

  let wPos = workspace.getPosition();
  let scale = sqftConfig.scale;
  let offset = {
    x: (pos.x + wPos.x) / scale,
    y: (pos.y + wPos.y) / scale
  };

  return new PointV2(offset.x, offset.y, workspace, pointState, pointDesign);
}

/**
 * @param existingWallPoint {PointV2}
 * @param mousePos {{x: int, y: int}}
 * @param lockedAngleStep
 * @return {PointV2}
 */
export const getWallLockedPoint = (existingWallPoint, mousePos, lockedAngleStep = 45) => {
  const reduxState = store.getState();
  const isWallsLockMode = reduxState.sqftMenuState.isWallsLockMode;
  const newWallPoint = getWallPoint(mousePos);
  if (isWallsLockMode) {
    const lockedPosition = getLockPointPos(existingWallPoint, lockedAngleStep);
    const lockedPositionOnField = getMousePositionOnField(lockedPosition.x, lockedPosition.y);
    newWallPoint.setPosition(lockedPositionOnField);
  }

  return newWallPoint
}
